/**
 * 模組程式草稿：組出建立／更新模組 API 的 programs 欄位
 */

/**
 * @param {Array<{id: string, allowedPermissions?: string[]|null}>} programs
 * @returns {Array<{programId: string, allowedPermissions: string[]|null}>}
 */
export function buildModuleProgramsPayload(programs) {
  return (programs || []).map((program) => {
    const allowed = program.allowedPermissions;
    return {
      programId: program.id,
      allowedPermissions:
        !allowed || (Array.isArray(allowed) && allowed.length === 0)
          ? null
          : [...allowed]
    };
  });
}

/**
 * 將選定程式加到草稿清單尾端（略過已存在的）
 * @param {Array} current
 * @param {Array} selectedPrograms - 含 id 與可選 allowedPermissions
 * @returns {Array}
 */
export function appendProgramsToDraft(current, selectedPrograms) {
  const existingIds = new Set((current || []).map((item) => item.id));
  const toAppend = (selectedPrograms || []).filter((item) => item && item.id && !existingIds.has(item.id));
  return [...(current || []), ...toAppend];
}

/**
 * 拖拉調整草稿順序；from／to 相同或越界則回傳複本
 */
export function reorderProgramsInDraft(current, fromIndex, toIndex) {
  const items = [...(current || [])];
  if (
    fromIndex === toIndex
    || fromIndex < 0
    || toIndex < 0
    || fromIndex >= items.length
    || toIndex >= items.length
  ) {
    return items;
  }
  const [moved] = items.splice(fromIndex, 1);
  items.splice(toIndex, 0, moved);
  return items;
}
